import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * Stellt eine Komponente dar, die als eine Spalte für Filter Group dient.
 */
@Component({
    selector: 'common-filter-item',
    template: `<common-form-field [label]="label">
        <div class="filter-group__value-field">
            <div class="filter-group__value-content">
                <ng-content></ng-content>
            </div>
            <a *ngIf="closeButton" href="javascript:" class="icon-shut filter-group__shut-icon"
                (click)="reset.emit()"></a>
        </div>
    </common-form-field>`,
    host: { class: 'filter-group__item col-12 col-md-6 col-lg-4 col-xl-3' }
})
export class FilterItemComponent {
    @Input() label: string;

    @Input() closeButton: boolean = false;

    @Output() reset: EventEmitter<void> = new EventEmitter<void>();
}
